// extracted by mini-css-extract-plugin
module.exports = {"backDrop":"TakeOverContainer_backDrop__TjLAc","message":"TakeOverContainer_message___G3b3"};